// extracted by mini-css-extract-plugin
export default {"root":"IconEmptyShortlist_root__ODs22"};